<template>
  <div>
    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :category-filter.sync="categoryFilter"
      :categories-options="categoriaOptions"
      @updateFilter="updatedFilter($event)"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
            </div>
          </b-col>
        </b-row>

      </div>
      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="findAll"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- <template #cell(item_nome)="data">
          <b-media
            vertical-align="center"
          >
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.item.item_nome)"
                :src="data.item.item.imagens > 0 ? data.item.item.imagens[0].caminho_imagem : null"
              />
            </template>
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.item.item_nome.length > 30 ? data.item.item.item_nome.substring(0, 30) + '...' : data.item.item.item_nome }}
            </span>
          </b-media>
        </template> -->
        <template #cell(item_nome)="data">
          <b-media
            vertical-align="center"
          >
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.item.item_nome }}
            </span>
          </b-media>
        </template>

        <template #cell(texto)="data">
          <b-media vertical-align="center">
            <span class="font-weight-bold d-block text-nowrap">
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="cursor-pointer ml-1"
                v-b-tooltip.hover
                title="Ver texto completo"
                @click="showTextoModal(data.item.texto)"
              />
            </span>
          </b-media>
        </template>

        <template #cell(preco)="data">
          <span
            v-if="data.item.item.tabela_preco_itens.length > 0"
            class="text-nowrap"
          >
            {{ data.item.item.tabela_preco_itens[0].preco_venda | currency }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            Não informado
          </span>
        </template>

        <template #cell(afiliado)="data">
          <span class="text-nowrap">
            <a
              href="#"
              class="text-body"
              @click.prevent="openUserModal(data.item.afiliado.usuario.id)"
            >
              {{ `${data.item.afiliado.usuario.nome_responsavel} ${data.item.afiliado.usuario.sobrenome}` }}
            </a>
          </span>
        </template>

        <template #cell(status)="data">
          <span class="text-nowrap">
            <b-badge
              :variant="getStatusVariant(data.item.aprovado)"
              class="text-capitalize"
            >
              {{ data.item.aprovado }}
            </b-badge>
          </span>
        </template>

        <template #cell(actions)="data">
          <b-button
            size="sm"
            variant="success"
            class="mr-1"
            @click="acceptLinkAfiliado(data.item.id)"
          >
            Aceitar
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            @click="rejectLinkAfiliado(data.item.id)"
          >
            Recusar
          </b-button>
        </template>

        <!-- <template #cell(preco)="data">
          <span
            v-if="data.item.tabela_preco_itens.length > 0"
            class="text-nowrap"
          >
            {{ data.item.tabela_preco_itens[0].preco_venda | currency }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            {{ data.item.preco_venda | currency }}
          </span>
        </template> -->

        <!-- <template #cell(categoria)="data">
          <span
            v-if="data.item.categoria"
            class="text-nowrap"
          >
            {{ data.item.categoria.nome }}
          </span>
          <span
            v-else
            class="text-nowrap"
          >
            -
          </span>
        </template> -->

        <!-- <template #cell(data_inclusao)="data">
          <span class="text-nowrap">
            {{ data.item.data_inclusao | formatDateTimeBr }}
          </span>
        </template> -->

        <!-- Column: Id -->
        <!-- <template #cell(id)="data">
          <b-link
            :to="{ name: 'app-adm-produto-view', params: { id: data.item.id }}"
            class="font-weight-bold"
          >
            #{{ data.item.id }}
          </b-link>
        </template> -->

        <!-- <template #cell(item_descricao)="data">
          <span v-html="data.value" />
        </template> -->

        <!-- Column: Status -->
        <!-- <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : data.item.ativo === 0 ? 'Inativo' : 'Deletado' }}
          </b-badge>
        </template> -->
        <!-- <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template> -->
        <!-- Column: Actions -->
        <!-- <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('read', 'ADMIN_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Visualizar'"
              size="20"
              style="color: var(--secondary);"
              icon="EyeIcon"
              class="icon-activity"
              @click.stop="viewProduto(data.item.id)"
            />
            <feather-icon
                v-if="$can('update', 'ADMIN_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editCliente(data.item.id)"
            />
            <feather-icon
                v-if="$can('delete', 'ADMIN_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Deletar'"
              v-b-modal.modal-confirme-delete-cliente
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idProduto = data.item.id"
            />
          </div>
        </template> -->

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalClientes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
        <b-modal
          id="modal-texto-completo"
          title="Mensagem de Solicitação"
          ok-only
          ok-title="Fechar"
        >
          <pre class="text-wrap modal-texto">{{ textoCompleto }}</pre>
        </b-modal>
        <b-modal
          id="modal-justificativa"
          title="Justificativa da Rejeição"
          @ok="handleModalConfirm"
          ok-title="Confirmar"
          cancel-title="Cancelar"
        >
          <b-form-textarea
            v-model="justificativaTexto"
            placeholder="Digite o motivo da rejeição..."
            rows="3"
            max-rows="6"
          />
        </b-modal>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-cliente"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir esse cliente?"
      @ok="deleteCategory"
    />
    <modal-user :modal-id="'modal-user'" />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Vue from 'vue'
import Clipboard from 'v-clipboard'
import axios from '@axios'
import store from '@/store'
import {
  ref, onMounted, getCurrentInstance,
} from '@vue/composition-api'
import ModalConfirm from '@/components/ModalConfirm.vue'
import ModalUser from '@/components/ModalUser.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import useGerenciarList from '@/views/apps/produtos/list/useGerenciarList'
import router from '@/router'
import { currency, formatDateTimeBr, avatarText } from '@core/utils/filter'
import UsersListFilters from '../list/ItemProdutoListFilters.vue'

Vue.use(Clipboard)

export default {
  components: {
    UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BFormTextarea,
    BPagination,
    ModalConfirm,
    vSelect,
    ModalUser,
  },
  methods: {
    getStatusVariant(status) {
      if (status === 'Pendente') return 'warning'
      if (status === 'Aprovado') return 'success'
      if (status === 'Negado') return 'danger'
      return 'secondary'
    },
    onCopySuccess(e) {
      this.$bvToast.toast('URL copiada com sucesso!', {
        title: 'Sucesso',
        variant: 'success',
        solid: true,
      })
    },
    onCopyError(e) {
      this.$bvToast.toast('Erro ao copiar URL.', {
        title: 'Erro',
        variant: 'danger',
        solid: true,
      })
    },
    async deleteLinkAfiliado(id) {
      try {
        await axios.delete(`/linkafiliado/${id}`)
        this.$bvToast.toast('Afiliação deletada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
        // Recarregar a lista de afiliados ou atualizar a tabela
        this.refetchData()
      } catch (error) {
        this.$bvToast.toast('Erro ao deletar afiliação.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  filters: {
    currency,
    formatDateTimeBr,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const toast = useToast()

    const textoCompleto = ref('')

    const justificativaTexto = ref('')
    const pendingActionId = ref(null)

    const showTextoModal = (texto) => {
      textoCompleto.value = texto
      proxy.$bvModal.show('modal-texto-completo')
    }

    const openUserModal = userId => {
      proxy.$bvModal.show('modal-user')
      proxy.$root.$emit('user-modal-opened', userId)
    }

    const idProduto = ref(null)
    const blankCategoryData = ref({
      id: null,
      item_nome: '',
      item_descricao: '',
      id_categoria: '',
      ativo: 1,
      imagens: [],
    })

    const {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      categoriaOptions,
      categoryFilter,
    } = useGerenciarList()

    const acceptLinkAfiliado = async (id) => {
      try {
        await axios.put(`/linkafiliado/${id}`, {
          aprovado: 'Aprovado',
        })
        toast({
          component: ToastificationContent,
          props: {
            title: 'Afiliação aprovada com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        // Atualizar a tabela ou recarregar os dados
        refetchData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao aprovar afiliação',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    const rejectLinkAfiliado = (id) => {
      pendingActionId.value = id
      justificativaTexto.value = ''
      proxy.$bvModal.show('modal-justificativa')
    }

    const handleModalConfirm = async () => {
      try {
        await axios.put(`/linkafiliado/${pendingActionId.value}`, {
          aprovado: 'Negado',
          texto: justificativaTexto.value,
        })
        toast({
          component: ToastificationContent,
          props: {
            title: 'Afiliação negada com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        refetchData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao negar afiliação',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    const gruposOptions = ref([])

    const updatedFilter = e => {
      if (e.status) {
        statusFilter.value = e.status
      }
      if (e.id_categoria !== null) {
        const categoria = JSON.parse(JSON.stringify(e.id_categoria))
        categoryFilter.value = categoria.id
      }
      refetchData()
    }

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addCliente = async () => {
      blankCategoryData.value = {
        id: null,
        item_nome: '',
        item_descricao: '',
        id_categoria: '',
        ativo: 1,
        imagens: [],
      }
      isAddNewUserSidebarActive.value = true
    }

    const editCliente = id => {
      router.push({ name: 'app-adm-produto-add', params: { id } })
    }

    const viewProduto = id => {
      router.push({ name: 'app-adm-produto-view', params: { id } })
    }

    const deleteCategory = async () => {
      await store.dispatch('appAdmProdutos/delete', { id: idProduto.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idProduto.value = null
          refetchData()
        })
      refetchData()
    }

    onMounted(() => {
      store.dispatch('appLinkAfiliado/findAll')
    })
    return {
      acceptLinkAfiliado,
      rejectLinkAfiliado,
      idProduto,
      addCliente,
      blankCategoryData,
      editCliente,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      updatedFilter,
      deleteCategory,
      viewProduto,
      categoriaOptions,
      categoryFilter,
      textoCompleto,
      showTextoModal,
      justificativaTexto,
      handleModalConfirm,
      openUserModal,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}

.modal-texto {
  font-size: 1.1rem; /* Aumenta o tamanho da fonte */
  line-height: 1.5; /* Melhora o espaçamento entre linhas */
  font-family: inherit; /* Usa a fonte padrão do sistema ao invés da fonte monospace do pre */
  white-space: pre-wrap; /* Permite quebra de linha automática */
  padding: 1rem; /* Adiciona um espaçamento interno */
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
